import { useEffect, useState } from "preact/hooks"
import { HintButton } from "./hint"
import { Icon } from "./icon.js"

const gettext = window.gettext

export const Checkboxes = (props) => {
  const classList = () => {
    const classes = ["checkboxes"]
    props.singular || classes.push("multiple")
    props.class && classes.push(props.class)
    return classes.join(" ")
  }
  const reporterType = props.form.inFormValues({
    name: "reporter_type",
  })

  return (
    <fieldset class={classList()}>
      {props.label && <legend class="show-for-sr">{props.label}</legend>}
      {props.fields.map((f) => {
        const hint = props.hints?.[f[0]]
        const display = f[2] ? f[2] === reporterType?.value : true

        return display
          ? <Checkbox
              key={`${props.form.stepId}-${props.name}-${f[0]}`}
              field={f}
              singular={props.singular}
              function={props.function}
              name={props.name}
              form={props.form}
              icons={props.icons ?? false}
            >
              {hint && (
                <HintButton
                  title={hint.title}
                  onClick={() => {
                    props.form.openHint(hint)
                  }}
                />
              )}
            </Checkbox>
          : null
      })}
    </fieldset>
  )
}

export const Checkbox = (props) => {
  const [value, initialLabel] = props.field
  const { name } = props

  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (value === "mixed") {
      setDisabled(
        props.form.inFormValues({ name: "perpetrator_count", value: "single" }),
      )
    }
  })

  const checkSingularCondition = (condition) => {
    if (condition === "perpetrator_count") {
      return singlePerpetrator()
    }
    return !!condition
  }

  const isRequired = () => {
    return !props.form.requirementsMet(name)
  }

  const singlePerpetrator = () => {
    return props.form.inFormValues({
      name: "perpetrator_count",
      value: "single",
    })
  }

  const singular = checkSingularCondition(props.singular)

  const onChange = () => {
    setDisabled(true)
    props.form.toggleValue(
      {
        step: props.form.stepId,
        name,
        label,
        value,
      },
      singular,
      props.function === "switch"
        ? ["perpetrator_role", "perpetrator_age", "perpetrator_gender"]
        : false,
    )

    props.function === "onClickNext" && props.form.showStep(1)

    setDisabled(false)
  }

  const label =
    props.conditional_label &&
    (value === "other" || value === "other_unknown") &&
    singlePerpetrator()
      ? props.conditional_label
      : initialLabel

  return (
    <div class="checkbox" key={`${name}-${value}`}>
      <input
        id={`${name}-${value}`}
        type="checkbox"
        value={value}
        name={name}
        disabled={disabled}
        checked={props.form.inFormValues({ name, value }) || false}
        onChange={onChange}
      />
      <label
        for={`${name}-${value}`}
        additional-label={gettext("melden")}
        class={
          props.icons
            ? `w-icon ${value} ${isRequired() && "required"}`
            : `${isRequired() && "required"}`
        }
      >
        {label}
        {props.icons && <Icon name={value} />}
      </label>
      {props.children}
    </div>
  )
}
